document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');

    searchBars.forEach(searchBar => {

        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            const section_name = 'v2-predictive-search';


            if (searchBar.value.length > 2) {

                var requestResponse;
                fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product,collection,article,page&section_id=${section_name}`)
                    .then((response) => {
                        requestResponse = response;
                        return response.text();
                    })
                    .then((text) => {
                        if (!requestResponse.ok) {
                            throw new Error(`${requestResponse.status}: ${text}`);
                        }
                        resultsWrapper.classList.add('active');

                        const resultsMarkup = new DOMParser()
                            .parseFromString(text, 'text/html')
                            .querySelector(`#shopify-section-${section_name}`).innerHTML;

                        resultsContainer.innerHTML = resultsMarkup;

                        document.body.classList.add('fixed');

                        const view_all = document.querySelector('.search-products__heading a');

                        view_all.setAttribute('href', `/search?q=${searchBar.value}&type=product`)

                        // Mobile sidebar accordion
                        const sidebarContainers = document.querySelectorAll('.search-sidebar-container');

                        sidebarContainers.forEach((block) => {
                            const header = block.querySelector('h2');
                            const links = block.querySelector('.search-sidebar-links');

                        header.addEventListener('click', (e) => {
                            e.preventDefault();

                            header.classList.toggle('active');
                            links.classList.toggle('active');
                        })
                    })
                    document.querySelectorAll('.close-mobile-search').forEach(closeMobileSearch => {
                        closeMobileSearch.classList.add('active');
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.classList.remove('active');
            }
        }

        let searchMethod = predictiveSearchCallBack;

        if (searchBar && resultsContainer) {
            searchBar.addEventListener('keyup', searchMethod)
            let closeButton = resultsWrapper.querySelector('.close');
            closeButton.addEventListener('click', () => {
                resultsWrapper.classList.remove('active');
                document.body.classList.remove('fixed');
                document.querySelectorAll('.header-search').forEach(searchInput => {
                    searchInput.value = '';
                })
                document.querySelectorAll('.close-mobile-search').forEach(closeMobileSearch => {
                    closeMobileSearch.classList.remove('active');
                });
            })
            document.addEventListener('click', (e) => {
                const target = e.target.closest('.close-mobile-menu');
                if(e.target.closest('.close-mobile-menu')) {
                    resultsWrapper.classList.remove('active');
                    document.body.classList.remove('fixed');
                    document.querySelectorAll('.header-search').forEach(searchInput => {
                        searchInput.value = '';
                    })
                    document.querySelectorAll('.close-mobile-search').forEach(closeMobileSearch => {
                        closeMobileSearch.classList.remove('active');
                    });
                } else if (e.target.closest('.close-mobile-search')) {
                    resultsWrapper.classList.remove('active');
                    document.body.classList.remove('fixed');
                    document.querySelectorAll('.header-search').forEach(searchInput => {
                        searchInput.value = '';
                    })
                    document.querySelectorAll('.close-mobile-search').forEach(closeMobileSearch => {
                        closeMobileSearch.classList.remove('active');
                    });
                }
            })
        }
    })


    // SCROLL HANDLER

    function calculateHeaderHeight() {
        //const ruler = document.querySelector('.header-ruler');
        const vw = window.innerWidth;
        const header = document.querySelector('section.mega-menu-outer-shopify-wrapper');
        const predictive_search = document.querySelector('.predictive-search-container');
        const header_box = header.getBoundingClientRect();
        const header_top = header_box.top;
        const header_height = header_box.height;
        const header_dist = header_top + header_height;

        // ruler.style.setProperty('--ruler-top', `${ header_dist }px` );
        predictive_search.style.setProperty('--ruler-top', `${ header_dist }px` );
    }

    // On Scroll
    let headerTimeout;
    document.addEventListener('scroll', (e) => {
        clearTimeout(headerTimeout);

        headerTimeout = setTimeout(() => {
            calculateHeaderHeight();
        }, 200);
    });

    // On Load
    calculateHeaderHeight();

});